import React, { useMemo } from "react";
import styles from "./TableHeading.module.scss";
import { DateRangePicker } from "../../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { Select } from "../../../../../../../shared/Select/Select";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";

export const TableHeading = ({ isReportsLoading, period, clinic }) => {
  const { data: user } = useCurrentUserQuery();
  const { tBi } = useAppTranslation.BusinessInsights();

  const clinicOptions = useMemo(() => {
    const allClinicsOption = {
      label: tBi("verticalsUsageReport.filter.allClinics"),
      value: null,
    };

    const options = clinic?.options || [];

    return [allClinicsOption, ...options];
  }, [clinic?.options]);

  const selectedClinic = useMemo(() => {
    return (
      clinicOptions.find((opt) => opt.value === clinic?.value) ||
      clinicOptions[0]
    );
  }, [clinicOptions, clinic?.value]);

  return (
    <div className={styles.root}>
      <Select
        size="small"
        value={selectedClinic}
        onChange={(option) => clinic?.onChange(option?.value || null)}
        options={clinicOptions}
        isDisabled={isReportsLoading}
        className={styles.clinicsSelect}
        isSearchable
      />
      <DateRangePicker
        isDisabled={isReportsLoading}
        size="small"
        dateFormat={user?.dateFormat}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
    </div>
  );
};
